import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { APP_LOGO } from "@/lib/constants";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async () => {
    setError("");
    if (pw.length < 6) { setError("Password minimal 6 karakter"); return; }
    if (pw !== pw2) { setError("Konfirmasi password tidak cocok"); return; }
    setLoading(true);
    try { await api.post("/auth/reset-password", { token, password: pw }); toast.success("Password berhasil diubah"); navigate("/login"); }
    catch (e) { setError(formatApiError(e.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream px-6">
      <div className="w-full max-w-sm animate-fade-up">
        <div className="flex justify-center mb-8"><img src={APP_LOGO} alt="Primrose" className="h-28 w-auto object-contain" /></div>
        <div className="card-lux p-6">
          <h3 className="font-heading text-2xl text-[#1A1A1A] mb-1">Reset Password</h3>
          {!token ? (
            <p className="text-sm text-red-600">Token tidak ditemukan. Minta tautan baru dari halaman <Link to="/forgot-password" className="underline">Lupa Password</Link>.</p>
          ) : (
            <>
              <p className="text-sm text-[#7A7A7A] mb-5">Buat password baru untuk akun Anda.</p>
              <Label className="text-xs font-semibold text-[#4A4A4A] mb-1.5 block">Password Baru</Label>
              <Input data-testid="reset-pw" type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="bg-white mb-3" />
              <Label className="text-xs font-semibold text-[#4A4A4A] mb-1.5 block">Konfirmasi Password</Label>
              <Input data-testid="reset-pw2" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="bg-white mb-3" />
              {error && <p className="text-sm text-red-600 mb-3">{error}</p>}
              <Button onClick={submit} disabled={loading} data-testid="reset-submit" className="w-full bg-burgundy hover:bg-burgundy-dark text-white rounded-full py-6">{loading ? "Menyimpan..." : "Simpan Password Baru"}</Button>
            </>
          )}
          <Link to="/login" className="block text-center mt-4 text-sm text-[#7A7A7A] hover:text-burgundy">Kembali ke login</Link>
        </div>
      </div>
    </div>
  );
}
